<template>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">{{ published ? 'Lien public' : 'Publier la ligne du temps' }}</p>
		</header>
		<section class="modal-card-body has-text-centered">
            <p v-if="!published">
                Publiez votre ligne du temps afin de créer un lien public vers celle-ci.<br />
                Toute personne qui dispose de ce lien pourra visualiser votre ligne du temps.
            </p>

            <div v-if="published">
                <p>
                    Cette ligne du temps est accessible via le lien public ci-dessous. <br />
                    Partagez-le avec vos contacts pour qu'ils puissent la visualiser.
                </p>

                <p class="has-text-centered" style="padding: 1rem;">
                    <a :href="url" target="_blank" style="font-size: 120%;">{{ url }}</a>
                    <br />
                    <b-loading :is-full-page="false" :active.sync="loadQR"></b-loading>
                    <svg width="200" height="200" style="padding: 10px;">
                        <image :xlink:href="qr" width="180" height="180" :onload="loadQR=false"></image>
                    </svg>
                    <br />
                    <a :href="qr" download class="button is-primary" v-if="qr">
                        Télécharger le code QR
                    </a>
                </p>
            </div>
		</section>
		<footer class="modal-card-foot" v-if="policies.publish">
            <div class="field">
                <div class="control">
                    <button class="button is-primary" @click="submit()" :disabled="form.processing" v-if="!published">
                        <i class="fa fa-spinner fa-pulse" v-show="form.processing"></i>
                        &nbsp;
                        <span>Publier la ligne du temps</span>
                    </button>
                    <button class="button is-danger" @click="destroy()" :disabled="form.processing" v-if="published">
                        <i class="fa fa-spinner fa-pulse" v-show="form.processing"></i>
                        &nbsp;
                        <span>Supprimer le lien public</span>
                    </button>
                    <button class="button" type="button" @click="$parent.close()">Annuler</button>
                </div>
            </div>
        </footer>
	</div>
</template>

<script>
import Form from 'form-backend-validation';

export default {
    props: ['timeline', 'policies'],

    data() {
        return {
            loadQR: true,
            url: this.timeline.public_link_url,
            qr: this.timeline.public_link_qr_code,
            published: this.timeline.published,
            form: new Form({}),
        }
    },
    
    methods: {

        submit() {

            this.form.post('/api/v1/timelines/' + this.timeline.id + '/publish')
            .then( response => {

                this.published = true;
                this.url = response.public_link_url;
                this.qr = response.public_link_qr_code;
                
                this.$buefy.toast.open({
                    message: 'Votre ligne du temps est désormais publique',
                    type: 'is-success'
                });

                Bus.$emit('timeline.fetch');

            }).catch(response => {
                this.$buefy.toast.open({
                    message: 'Une erreur s\'est produite',
                    type: 'is-danger'
                });
            });
        },

        destroy() {

            axios.delete('/api/v1/timelines/' + this.timeline.id + '/publish')
            .then( response => {

                this.published = false;
                this.url = null;
                this.qr = null;

                this.$buefy.toast.open({
                    message: 'Le lien public a été supprimé',
                    type: 'is-success'
                });

                Bus.$emit('timeline.fetch');
                
                this.$parent.close()

            }).catch(response => {
                this.$buefy.toast.open({
                    message: 'Une erreur s\'est produite',
                    type: 'is-danger'
                });
            });
        },
    },
}

</script>

<style>
</style>
